import type { RefObject } from "react";

type PronunciationGuideProps = {
  open: boolean;
  onClose: () => void;
  dialogRef: RefObject<HTMLElement | null>;
  word: string;
  pronunciation: string;
};

export function PronunciationGuide({
  open,
  onClose,
  dialogRef,
  word,
  pronunciation,
}: PronunciationGuideProps) {
  if (!open) return null;

  return (
    <div className="pronunciation-guide-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        ref={dialogRef}
        className="pronunciation-guide"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pronunciation-guide-title"
        tabIndex={-1}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header>
          <span className="section-kicker">Pronunciation guide</span>
          <button type="button" onClick={onClose} aria-label="Close pronunciation guide">×</button>
        </header>
        <h2 id="pronunciation-guide-title">How to read {word || "this word"}.</h2>
        <section className="pronunciation-guide-current" aria-label={`Current pronunciation for ${word || "this word"}`}>
          <span>Current word</span>
          <strong>{word || "This word"}</strong>
          <p>{pronunciation || "Use Hear while a readable written pronunciation is being prepared."}</p>
        </section>
        <div className="pronunciation-guide-grid">
          <section>
            <strong>SUR-kum-spekt</strong>
            <p>Capital letters mark the stressed part. Say that part a little more clearly.</p>
          </section>
          <section>
            <strong>Hyphens</strong>
            <p>They separate the spoken parts of a word. They are not pauses.</p>
          </section>
          <section>
            <strong>IPA</strong>
            <p>Some entries use this precise sound alphabet between slashes. If a plain respelling is shown, begin there. Otherwise Hear is the quickest first step.</p>
          </section>
          <section>
            <strong>Hear</strong>
            <p>The voice comes from your device. Its accent may differ from the written guide.</p>
          </section>
        </div>
        <p className="pronunciation-guide-note">
          A pronunciation can vary by accent. Verbalore shows the maintained evidence it has and does not pretend that one accent is the only correct one.
        </p>
        <button className="primary-action" type="button" onClick={onClose}>Return to this word</button>
      </section>
    </div>
  );
}
